import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import httpRequest from "../../axios/index";
import { setIsInvitationActive } from "../../redux/slices/InvitationSystem/InvitationSlice";
import { useDispatch } from "react-redux";


const ProtectedRoute = ({ children }) => {

  const { email, code } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    fetchInvitationMode();
  }, []);

  const fetchInvitationMode = async () => {
    try {
      const response = await httpRequest.get("api/user/getinvitationmode");
      const isActive = response?.data?.data?.isActive;
      dispatch(setIsInvitationActive(isActive));

      if (isActive) {
        fetchData();
      } else {
        setLoading(false);
      }
    } catch (error) {
      navigate("/auth/login");
    }
  };

  const fetchData = async () => {
    if (!code || !email) {
      navigate("/waitinglistuser");
      return;
    }
    try {
      const response = await httpRequest.get(
        `api/user/checked-email/${email}/${code}`
      );

      if (response.data.status === "failed") {
        navigate("/waitinglistuser");
      } else {
        setLoading(false);
      }
    } catch (error) {
      navigate("/waitinglistuser");
    }
  };

  return loading ? null : <>{children}</>;
};

export default ProtectedRoute;
